export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6576.46c7c240.jpg";